import admin from './admin'

const base = {
  BASE_URL: 'psm/gdp/',
  api: [{
      name: 'queryDeclare',
      desc: '获取申报表单明细',
      method: 'GET',
      path: '/query'
    },
    {
      name: 'config-update',
      desc: '更新系统配置',
      method: 'POST',
      path: '/config/update'
    },
    {
      name: 'config-query',
      desc: '查询系统配置',
      method: 'GET',
      path: '/config/query'
    },{
      name: 'history',
      desc: '历史申报',
      method: 'GET',
      path: '/admin/history'
    }
  ]
}

export default {
  admin,
  base
}



// WEBPACK FOOTER //
// ./src/api/psm/gdp/index.js